import { slice, actions } from "./slice";

export { default as useAppSelector } from "./useSelector";

export { default as appThunks } from "./thunks";

export { actions as appActions };

export default slice;
